module.exports = __webpack_public_path__ + "static/img/m_name.25c11a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/jw/m_name.png
// module id = gX+m
// module chunks = 7